// Error bodies reach the client with two different casings. Controller responses are camelCase, but
// ExceptionHandlerMiddleware serialises ErrorResponseDto with default options, so anything it
// handles — every ForbiddenException and every relayed ProviderApiRequestException — arrives as
// { "Message": ... }. Reading only one casing silently drops the server's message.
export function getServerErrorMessage(error) {
  const data = error?.response?.data;

  return data?.Message || data?.message || "";
}
